export default __webpack_public_path__ + "static/media/send-invoice-icon.c3411a22.svg";